import { proforientationApplicationSelectors } from 'portfolio3/features/proforientation/model/selectors';
import { createSelector } from 'reselect';
import { extractDatesFromNestedItems } from 'utils';

export const proforientationApplicationExcursionsYearsSelector = createSelector(
  [proforientationApplicationSelectors.excursions],
  (proforientationApplicationExcursions) =>
    extractDatesFromNestedItems(
      [proforientationApplicationExcursions],
      [
        {
          type: 'date',
          field: 'unformattedEventDate',
        },
      ],
    ),
);
